<template>
  <div>
    <card v-if="spinning">
      <div class="row">
        <div class="col-md-12 text-center">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
    </card>
    <card>
      <!-- Header and Button -->
      <div class="header-section">
        <h2>Users</h2>
        <div class="row">
          <div class="col-sm-6">
            <el-input
              v-model="searchQuery"
              placeholder="Search by first name, last name, username, or email"
              clearable
              @clear="searchQuery = ''">
              <span slot="prepend">Search</span>
            </el-input>
          </div>
          <div class="col-sm-2">
            <el-button @click="searchQuery = ''">Clear</el-button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <el-button type="primary" @click="createOrUpdateUser">Create New User</el-button>
          </div>
        </div>
      </div>

      <el-table :data="filteredUsers">
        <el-table-column min-width="150" label="Username">
          <template slot-scope="{ row }">
            <el-input v-model="row.username" placeholder="Username"></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="150" label="Email">
          <template slot-scope="{ row }">
            <el-input v-model="row.email" placeholder="Email"></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="Password">
          <template slot-scope="{ row }">
            <div v-if="editingPasswordForUserId !== row.id">
              ****
              <el-button icon="el-icon-edit" size="mini" @click="editPassword(row.id)"></el-button>
            </div>
            <div v-else>
              <el-input
                v-model="row.password"
                type="password"
                placeholder="Enter new password"
                @blur="stopEditingPassword"
                @keyup.enter="stopEditingPassword">
              </el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="125" label="First Name">
          <template slot-scope="{ row }">
            <el-input v-model="row.first_name" placeholder="First Name"></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="125" label="Last Name">
          <template slot-scope="{ row }">
            <el-input v-model="row.last_name" placeholder="Last Name"></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="115" label="Phone">
          <template slot-scope="{ row }">
            <el-input v-model="row.phone" placeholder="Phone"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="Enabled">
          <template slot-scope="{ row }">
            <el-switch v-model="row.enabled"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="Notify">
          <template slot-scope="{ row }">
            <el-switch v-model="row.notify"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="Actions" width="150">
          <template slot-scope="{ row }">
            <el-button
              icon="el-icon-check"
              size="mini"
              @click="updateUser(row)"
              title="Update User">
            </el-button>
            <el-button
              icon="el-icon-delete"
              size="mini"
              @click="confirmDelete(row)"
              title="Delete User">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </card>
    <el-dialog
      center
      title="Success"
      :visible.sync="modals.success">
      <div class="text-center">
        <span>Success: {{ success_txt }}</span>
        <br>
        <span slot="footer" class="dialog-footer">
<button class="btn btn-success" @click="closeModal('success')">OK</button>&nbsp;
</span>
      </div>
    </el-dialog>
    <el-dialog
      center
      title="Error"
      :visible.sync="modals.error">
      <div class="text-center">
        <span>Error: {{ error_txt }}</span>
        <br>
        <span slot="footer" class="dialog-footer">
<button class="btn btn-danger" @click="closeModal('error')">OK</button>&nbsp;
</span>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="modals.create_user" title="Create New User">
      <el-form ref="createForm" :model="newUser" label-position="top" label-width="120px">
        <div class="row">
          <div class="col-sm-6">
            <el-form-item label="Username">
              <el-input v-model="newUser.username" placeholder="Enter username"></el-input>
            </el-form-item>
          </div>
          <div class="col-sm-6">
            <el-form-item label="Email">
              <el-input v-model="newUser.email" placeholder="Enter email"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <el-form-item label="Password">
              <el-input
                v-model="newUser.password"
                type="password"
                placeholder="Enter password"
                :suffix-icon="showPassword ? 'el-icon-view' : 'el-icon-eye-off'"
                @click:append="togglePasswordVisibility">
              </el-input>
              <!-- You can add a password strength indicator component below this input -->
            </el-form-item>

            <el-form-item label="Confirm Password" :error="passwordError">
              <el-input
                v-model="newUser.confirmPassword"
                type="password"
                placeholder="Confirm password">
              </el-input>
            </el-form-item>
          </div>
          <div class="col-sm-6">
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <el-form-item label="First Name">
              <el-input v-model="newUser.first_name" placeholder="First Name"></el-input>
            </el-form-item>
          </div>
          <div class="col-sm-6">
            <el-form-item label="Last Name">
              <el-input v-model="newUser.last_name" placeholder="Last Name"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <el-form-item label="Phone">
              <el-input v-model="newUser.phone" placeholder="Phone"></el-input>
            </el-form-item>
          </div>
          <div class="col-sm-6">
            <el-form-item label="Notifications">
              <el-switch v-model="newUser.notify"></el-switch>
            </el-form-item>
          </div>
        </div>

        <!-- List out password requirements -->
        <div style="font-size: 0.9em; color: grey;">
          Password requirements:
          <ul>
            <li>At least 8 characters</li>
            <li>At least one number</li>
            <li>At least one special character</li>
          </ul>
        </div>
        <el-form-item>
          <el-button type="primary" @click="createUser">Create</el-button>
          <el-button @click="closeModal('create_user')">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  Icon,
  Button,
  Dialog,
  Select,
  Option,
  Table,
  TableColumn,
  Checkbox,
  Input,
  Switch,
  Form,
  FormItem,
} from 'element-ui';
import { UserAPIService } from 'src/servicehandlers/UsersAPIService';

const usersAPIService = new UserAPIService();

export default {
  name: "UserAdmin",
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  data() {
    return {
      passwordError: '',
      newUser: {
        username: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        phone: '',
        sms: '',
        enabled: true,
        notify: true,
      },
      showPassword: false,
      modals: {
        error: false,
        success: false,
        create_user: false,
      },
      searchQuery: '',
      filteredUserOptions: [],
      editingPasswordForUserId: null,
      searchUserTerm: null,
      selected_user_id: null,
      error_txt: null,
      success_txt: null,
      spinning: false,
      username: null,
      first_name: null,
      last_name: null,
      password: null,
      enabled: true,
      users: [],
    }
  },
  computed: {
    filteredUsers() {
      const query = this.searchQuery.toLowerCase();
      return this.users.filter(user => {
        const firstName = user.first_name ? user.first_name.toLowerCase() : '';
        const lastName = user.last_name ? user.last_name.toLowerCase() : '';
        const username = user.username ? user.username.toLowerCase() : '';
        const email = user.email ? user.email.toLowerCase() : '';

        return firstName.includes(query) ||
          lastName.includes(query) ||
          username.includes(query) ||
          email.includes(query);
      });
    }
  },
  mounted() {
    this.getAllUsers();
  },
  methods: {
    arePasswordsSame() {
      return this.newUser.password === this.newUser.confirmPassword;
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    confirmDelete(user) {
      this.$confirm('Are you sure?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.deleteUser(user);
      }).catch(() => {
        // User canceled the delete action
      });
    },

    deleteUser(user) {
      // Remove the user from local data
      const index = this.users.indexOf(user);
      if (index !== -1) {
        this.users.splice(index, 1);
        return usersAPIService.deleteUser(user.id, this.$router)
        .then(() => {
          this.handleSuccess('Successfully delete user!');
        })
        .catch((error) => {
          this.handleError('Error while deleting user!: ' + error);
        });
      }
    },
    handleSuccess(text) {
      this.success_txt = text;
      this.openModal('success');
      this.spinning = false;
      setTimeout(() => {
        this.modals['success'] = false;
      }, 1500); // Hide after 1.5 secs
    },
    handleError(error) {
      this.error_txt = error;
      this.openModal('error');
      this.spinning = false;
      setTimeout(() => {
        this.modals['error'] = false;
      }, 1500); // Hide after 1.5 secs
    },
    editPassword(userId) {
      this.editingPasswordForUserId = userId;
    },
    stopEditingPassword() {
      this.editingPasswordForUserId = null;
      // Here, you can also send the updated password to your server
      // to save the changes permanently
    },
    getAllUsers() {
      return usersAPIService.getUserList(this.$router)
      .then((allUsers) => {
        this.users = allUsers;
      })
      .catch((error) => {
        this.error_txt = error;
        this.openModal('error');
      });
    },
    clear() {
      this.newUser.username = '';
      this.newUser.password = '';
      this.newUser.first_name = '';
      this.newUser.last_name = null;
      this.newUser.enabled = true;
      this.spinning = false;
      this.searchUserTerm = null;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    openModal(name) {
      this.modals[name] = true;
    },
    updateUser(user) {
      this.spinning = true;
      return usersAPIService.updateUser(user.id, user, this.$router)
      .then(() => {
        this.spinning = false;
        this.success_txt = 'Successfully updated user: ';
        this.openModal('success');
        this.searchUserTerm = null;
        this.getAllUsers();
      })
      .catch((error) => {
        this.spinning = false;
        this.error_txt = 'Error updating user: ' + error;
        this.openModal('error');
      });
    },
    createUser() {
      if (this.arePasswordsSame()) {
        this.passwordError = '';  // Clear any previous error message.
      } else {
        this.passwordError = 'Passwords do not match.';
        return;
      }
      if (!this.newUser.email) {
        this.handleError('No user email!');
        return;
      }
      if (!this.newUser.password) {
        this.handleError('No user password!');
        return;
      }
      if (!this.newUser.first_name) {
        this.handleError('No user first name!');
        return;
      }
      if (!this.newUser.last_name) {
        this.handleError('No user last name!');
        return;
      }
      this.closeModal('create_user');
      this.spinning = true;
      return usersAPIService.createUser(this.newUser, this.$router)
      .then((newUser) => {
        this.spinning = false;
        this.success_txt = 'Successfully created user: ';
        this.openModal('success');
        this.newUser.username = '';
        this.newUser.password = '';
        this.newUser.first_name = '';
        this.newUser.last_name = null;
        this.newUser.enabled = true;
        this.spinning = false;
        this.searchUserTerm = null;
        this.getAllUsers();
      })
      .catch((error) => {
        this.spinning = false;
        this.error_txt = 'Error creating user: ' + error;
        this.openModal('error');
      });
    },
    createOrUpdateUser() {
      this.openModal('create_user');
    }
  }
}
</script>

<style scoped>
.el-dialog {
  border-radius: 10px;
}

.el-form-item {
  margin-bottom: 20px;
}
</style>
